import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { createLogger } from '../../../shared/config/logger';

const logger = createLogger('QRScanner');

export default function QRScanner({ onScanSuccess }) {
    const scannerRef = useRef(null);
    const cameraId = 'qr-reader';

    useEffect(() => {
        let isMounted = true;
        const html5QrCode = new Html5Qrcode(cameraId);
        scannerRef.current = html5QrCode;

        const startScanner = async () => {
            try {
                const elementExists = document.getElementById(cameraId);
                if (!elementExists) {
                    logger.warn('QR container not found', { cameraId });
                    return;
                }

                const devices = await Html5Qrcode.getCameras();
                if (devices && devices.length && isMounted) {
                    await html5QrCode.start(
                        { facingMode: 'environment' },
                        { fps: 10, qrbox: 250 },
                        (decodedText) => {
                            onScanSuccess(decodedText);
                        },
                        (_err) => {
                            // Suppress scan errors
                        }
                    );
                }
            } catch (err) {
                logger.error('QR scanner failed to start', { error: err });
            }
        };

        startScanner();

        return () => {
            isMounted = false;
            if (html5QrCode && html5QrCode.getState() === 2) {
                // 2 = SCANNING
                html5QrCode
                    .stop()
                    .then(() => html5QrCode.clear())
                    .catch((err) => {
                        logger.warn('Error while stopping scanner', { error: err.message });
                    });
            }
        };
    }, [onScanSuccess]);

    return <div id={cameraId} />;
}
